<script>
import BlockContent from '../UI/Content/BlockContent.vue'
import DataTable from '../UI/Table/DataTable.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'

export default {
  components: { DataTable, BlockContent },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    entityId: { type: Number, required: true },
  },

  computed: {
    columns() {
      return [
        {
          name: 'simulationId',
          title: this.$t('demand.list.simulationId'),
          displayable: true,
          formatter: 'context',
          options: { renderType: 'simulation' },
        },
        { name: 'client.id', displayable: false },
        { name: 'refinancer.entity.id', displayable: false },
        { name: 'demandNumber', title: this.$t('demand.list.number'), style: { className: 'col-align-center' } },
        { name: 'createdAt', title: this.$t('demand.list.createdAt'), type: 'date', formatter: 'date' },
        {
          name: 'client.name',
          title: this.$t('demand.list.client'),
          formatter: 'entity',
          options: { renderId: 'client.id' },
        },
        {
          name: 'refinancer.entity.name',
          title: this.$t('demand.list.refinancer'),
          formatter: 'entity',
          displayable: user.isBusinessMan || user.isAdmin,
          options: { renderId: 'refinancer.entity.id' },
        },
        { name: 'platformSalesman.name', title: this.$t('demand.list.platformSalesman') },
        { name: 'finance.contractType.name', title: this.$t('demand.list.contractType') },
        { name: 'productType.name', title: this.$t('demand.list.productName') },
        { name: 'finance.amount', title: this.$t('demand.list.amountDemand'), formatter: 'currency', type: 'numeric' },
        {
          name: 'outstanding.availableContracts',
          title: this.$t('demand.list.amountAvailable'),
          formatter: 'currency',
          type: 'numeric',
        },
        { name: 'finance.duration', title: this.$t('demand.list.rentDuration') },
        { name: 'finance.rent', title: this.$t('demand.list.rent') },
        {
          name: 'status',
          title: this.$t('demand.list.status'),
          formatter: 'status',
          style: { className: 'col-align-center' },
          options: { renderType: 'simulation' },
        },
        {
          name: 'decisionMessage',
          title: this.$t('demand.list.message'),
          formatter: 'action',
          options: { renderType: 'comment' },
        },
        { name: 'decisionValidity', title: this.$t('demand.list.validity'), type: 'date', formatter: 'date' },
      ]
    },
    urlDemands() {
      let url = 'demands?entityId=' + this.entityId
      if (this.config.conf.demandStatuses) {
        url += '&statuses=' + this.config.conf.demandStatuses
      }
      return url
    },
  },

  methods: {
    getDemand(callback) {
      this.getJSON(this.urlDemands).then((demands) => {
        callback({ data: demands })
      })
    },
  },
}
</script>
<template>
  <BlockContent>
    <DataTable
      id="liste"
      :columns="columns"
      ref="listeAccordSociete"
      :fetch="getDemand"
      :order="[[0, 'desc']]"
      :zero-records="$t('contract.list.zeroRecords')"
    />
  </BlockContent>
</template>
